import { LoginFormModel } from '../models/login-model';

const deviceToken = '@vendor-checkin:deviceToken';
const storeIdString = '@vendor-checkin:storeId';

export const saveToken = async (token: string): Promise<void> => {
  return Promise.resolve(saveDeviceToken(token));
};

export function saveDeviceToken(token: string): Promise<any> {
  return new Promise((resolve, _) => {
    resolve(localStorage.setItem(deviceToken, token));
  });
}

export function getDeviceToken(): Promise<any> {
  return new Promise((resolve, _) => {
    resolve(localStorage.getItem(deviceToken));
  });
}

export const saveUserInfoamtion = (userInfo: LoginFormModel): void => {
  localStorage.setItem('userInfo', JSON.stringify(userInfo));
};

export const getUserInfo = (): LoginFormModel | null => {
  const userInfoString = localStorage.getItem('userInfo');
  return userInfoString ? JSON.parse(userInfoString) : null;
};

export const getVendorIdFromUserInfo = (): string | null => {
  const userInfo = getUserInfo();
  return userInfo ? userInfo.vendorId : null;
};

export const saveStoreId = async (storeId: string): Promise<void> => {
  return Promise.resolve(saveStoreIdFromUrl(storeId));
};

export function saveStoreIdFromUrl(storeId: string): Promise<any> {
  return new Promise((resolve, _) => {
    resolve(localStorage.setItem(storeIdString, storeId));
  });
}

export function getStoreId(): Promise<any> {
  return new Promise((resolve, _) => {
    resolve(localStorage.getItem(storeIdString));
  });
}

/** removing it to get the timezone directly from the browser 
// export function saveXSwyTimeZone(timezoneFromComponent: string): void {
//  Need to remove in future
//     localStorage.setItem(xSwyTimeZone, timezone);
//    
//   localStorage.setItem(xSwyTimeZone, Intl.DateTimeFormat().resolvedOptions().timeZone || timezoneFromComponent);
// 
*/

export function getXSwyTimeZone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
